import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { orderHistory } from "../../types";

const orderHistoryInitialState: orderHistory.OrderHistoryStateType = {
  orderHistory: {
    data: null,
    isLoading: false,
    error: null,
  },
};

export const orderHistorySlice = createSlice({
  name: "orderHistory",
  initialState: orderHistoryInitialState,
  reducers: {
    getOrderHistoryRequest: (
      state: orderHistory.OrderHistoryStateType,
      action: PayloadAction<any>
    ) => {
      state.orderHistory.isLoading = true;
      state.orderHistory.error = null;
    },
    getOrderHistorySuccess: (
      state: orderHistory.OrderHistoryStateType,
      action: PayloadAction<any>
    ) => {
      // state.orderHistory.isLoading = false;
      // const response = action.payload?.data;

      // if (response) {
      //   // If it's the first page, replace data, otherwise append
      //   if (state.orderHistory.data === null) {
      //     state.orderHistory.data = response.data || [];
      //   } else {
      //     state.orderHistory.data = [
      //       ...(state.orderHistory.data || []),
      //       ...(response.data || []),
      //     ];
      //   }

      //   state.orderHistory.totalCount = response.total_count || 0;
      //   state.orderHistory.hasMore = response.has_more || false;
      // }
      //console.log("action.payload", action.payload);
      state.orderHistory.isLoading = false;
      state.orderHistory.data = action.payload;
      //state.orderHistory.totalCount = action.payload?.total_lab_tests || 0;
      //state.orderHistory.hasMore = action.payload?.has_more || false;
    },
    getOrderHistoryError: (
      state: orderHistory.OrderHistoryStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.orderHistory.isLoading = false;
      state.orderHistory.error = error;
    },
    resetOrderHistory: (state: orderHistory.OrderHistoryStateType) => {
      state.orderHistory = {
        data: null,
        isLoading: false,
        error: null,
      };
    },
  },
});

export const {
  getOrderHistoryRequest,
  getOrderHistorySuccess,
  getOrderHistoryError,
  resetOrderHistory,
} = orderHistorySlice.actions;

export default orderHistorySlice.reducer;
